/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */

import { Conversation } from '@twilio/conversations';
import jwtDecode from 'jwt-decode';

import { DecodedToken } from './types';

export const getIdentityFromUser = (token: string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const decoded = jwtDecode(token) as DecodedToken;
  return decoded?.grants?.identity;
};

export const findConversationByPatientId = async (
  patientId: string,
  conversations: Conversation[],
) => {
  let conversationByPatientId;

  for (const conversation of conversations) {
    const participants = await conversation.getParticipants();

    const findConversationFromParticipantIdentify = participants.find(
      participant => {
        const { identity } = participant;

        return identity === patientId;
      },
    );

    if (findConversationFromParticipantIdentify) {
      conversationByPatientId = conversation;
    }
  }

  return conversationByPatientId;
};
